import { useRef, useEffect } from 'react'

/**
 * https://reactjs.org/docs/hooks-faq.html#how-to-get-the-previous-props-or-state
 */
function usePrevious(value: any): any {
    const ref = useRef()

    useEffect(() => {
        ref.current = value
    })

    return ref.current
}

export default usePrevious
